import { Mail, ShieldCheck, Zap } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const Banner = () => {
  const { isAuthenticated } = useAuth();

  const handleSubscribe = () => {
    if (isAuthenticated) {
      window.location.hash = "#dashboard";
    } else {
      const event = new CustomEvent("open-auth-modal", { detail: { tab: "signup" } });
      window.dispatchEvent(event);
    }
  };

  return (
    <div className="group relative w-full max-w-4xl transition-transform hover:scale-[1.01]">
      {/* Glow Effect Warna Purple kau */}
      <div className="absolute -inset-0.5 rounded-2xl bg-gradient-to-r from-brand-purple to-brand-electric opacity-30 blur group-hover:opacity-60 transition duration-500"></div>
      
      {/* Inner Box */}
      <div className="relative flex flex-col md:flex-row items-center gap-6 rounded-2xl bg-slate-900/90 border border-white/10 p-6 backdrop-blur-md">
        
        {/* Visual Email Server (Mini UI) */}
        <div className="w-full md:w-1/3 rounded-lg bg-black/40 border border-brand-purple/20 p-4 font-mono text-[10px] text-brand-electric">
          <div className="flex gap-1.5 mb-3">
            <div className="w-2 h-2 rounded-full bg-red-500/50" />
            <div className="w-2 h-2 rounded-full bg-yellow-500/50" />
            <div className="w-2 h-2 rounded-full bg-green-500/50" />
          </div>
          <div className="flex items-center gap-2 text-white mb-2">
            <Mail size={12} className="text-brand-purple" />
            <span className="opacity-70">mail.yourdomain.com</span>
          </div>
          <div className="space-y-1.5">
            <div className="h-1.5 w-full bg-white/5 rounded flex overflow-hidden">
              <div className="h-full w-full bg-brand-purple animate-pulse" />
            </div>
            <div className="flex justify-between opacity-60">
              <span>Security: 256-bit AES</span>
              <span className="text-green-400">Encrypted</span>
            </div>
          </div>
          <div className="mt-3 p-2 bg-brand-purple/10 rounded border border-brand-purple/20">
            <p className="text-white">New message: Welcome to privacy</p>
          </div>
        </div>

        {/* Content SaaS */}
        <div className="flex-1 text-left">
          <div className="flex items-center gap-2 text-brand-electric text-xs font-bold uppercase tracking-wider mb-2">
            <ShieldCheck size={14} />
            <span>Privacy First Email</span>
          </div>
          <h3 className="text-xl font-bold text-white mb-2">Self-Hosted Email Service</h3>
          <p className="text-slate-400 text-sm leading-relaxed mb-4">
           Organize your emails with our self-hosted email service. Keep your data safe and secure.
          </p>
          
          <button 
            onClick={handleSubscribe}
            className="flex items-center gap-2 rounded-lg bg-brand-purple px-5 py-2.5 text-sm font-semibold text-white hover:bg-brand-electric transition-all shadow-[0_0_15px_rgba(139,92,246,0.2)] hover:shadow-[0_0_20px_rgba(139,92,246,0.4)] cursor-pointer"
          >
            <Zap size={14} className="fill-white" />
            Subscribe Now
          </button>
        </div>
      </div>
    </div>
  );
};